export default "__VITE_PUBLIC_ASSET__fe434655__"